export const resellerReducer = (
  state = {
    loading: false,
    resellerList: null,
    resellerView: null,
    vrTransactionList: null,
    vrTransactionView: null,
    error: null,
  },
  action
) => {
  switch (action.type) {
    // RESELLER LIST
    case "GET_RESELLER_LIST_REQUEST":
      return { ...state, loading: true, error: null };

    case "GET_RESELLER_LIST_SUCCESS":
      return { ...state, loading: false, resellerList: action.payload, error: null };

    case "GET_RESELLER_LIST_FAILED":
      return { ...state, loading: false, resellerList: null, error: action.payload };

    // RESELLER VIEW
    case "GET_RESELLER_LIST_VIEW_REQUEST":
      return { ...state, loading: true, resellerView: null, error: null };

    case "GET_RESELLER_LIST_VIEW_SUCCESS":
      return { ...state, loading: false, resellerView: action.payload, error: null };

    case "GET_RESELLER_LIST_VIEW_FAILED":
      return { ...state, loading: false, resellerView: null, error: action.payload };

    // VR TRANSACTION LIST
    case "GET_VR_TRANSACTION_LIST_REQUEST":
      return { ...state, loading: true, error: null };

    case "GET_VR_TRANSACTION_LIST_SUCCESS":
      return { ...state, loading: false, vrTransactionList: action.payload, error: null };

    case "GET_VR_TRANSACTION_LIST_FAILED":
      return { ...state, loading: false, vrTransactionList: null, error: action.payload };

    // VR TRANSACTION VIEW
    case "GET_VR_TRANSACTION_VIEW_REQUEST":
      return { ...state, loading: true, vrTransactionView: null, error: null };

    case "GET_VR_TRANSACTION_VIEW_SUCCESS":
      return { ...state, loading: false, vrTransactionView: action.payload, error: null };

    case "GET_VR_TRANSACTION_VIEW_FAILED":
      return { ...state, loading: false, vrTransactionView: null, error: action.payload };

    // VR STATUS UPDATE
    case "VR_STATUS_UPDATE_REQUEST":
      return { ...state, loading: true, error: null };

    case "VR_STATUS_UPDATE_SUCCESS":
      return { ...state, loading: false, error: null };

    case "VR_STATUS_UPDATE_FAILED":
      return { ...state, loading: false, error: action.payload };

    // VR SCHEDULE APPOINTMENT
    case "VR_SCHEDULE_APPOINTMENT_REQUEST":
      return { ...state, loading: true, error: null };

    case "VR_SCHEDULE_APPOINTMENT_SUCCESS":
      return { ...state, loading: false, error: null };

    case "VR_SCHEDULE_APPOINTMENT_FAILED":
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};